interface MessageTypes {
  [key: string]: {
    productData: {
      [property: string]: any;
    };
    cryptoDeposit: {
      [property: string]: string;
    };
  };
}

const messages: MessageTypes = {
  en: {
    productData: {
      type: 'Type',
      ticker: 'Ticker',
      industry: 'Industry',
      sector: 'Sector',
      rebalanceFrequency: 'Rebalancing Frequency',
      monthly: 'Monthly',
      downloadFactsheet: 'Download Factsheet',
      factsheet: 'Factsheet',
      yourHoldings: 'Holdings',
      value: 'Current Value',
      about: 'About',
      gainLoss: 'Return',
      averageCostPrice: 'Avg. Buy Price',
      yield: 'Yield',
      date: 'Date',
      balance: 'Available Balance',
      maturity: 'Maturity',
      redeemButton: 'Redeem',
      performance: 'Performance',
      portfolioShare: 'Share of Portfolio',
      holdingsGainLossTooltip:
        'The estimated unrealised gain or loss before fees.',
      assetGainLossTooltip:
        'The data displayed is indicative only and its accuracy or completeness is not guaranteed. Your actual execution price may vary.',
      valueTooltip:
        "The estimated market value of your holding today.",
      averageCostTooltip:
        'The total cost of acquiring an asset, excluding any fees.',
      graphSubText1: 'Please refer to our',
      graphSubText2: 'fees page',
      graphSubText3: 'and additional important',
      graphSubText4: 'disclaimers',
      graphSubText5: 'and',
      graphSubText6: 'risk disclosures',
      notVerified: 'Verify to invest',
      verifyPending: 'Verification pending',
      investBtn: 'Buy',
      subscribeBtn: 'Subscribe',
      depositBtn: 'Deposit',
      pendingDeposit: 'Pending deposit',
      closeModal: 'Okay',
      sellBtn: 'Sell',
      modalDisclaimerHeader: 'Information',
      modalDisclaimerContent: [
        ' Returns are unaudited and do not include the fees and expenses that are charged.',
        'Actual returns may differ materially from historic returns and an investor may lose all or a substantial part of your investment in the Bundle. Any investment displayed here is intended to be used for informational purposes only and should not be relied upon as the sole basis for making any investment decision. Please note that the performance and information shared here is not intended to be a recommendation or advice to make an investment. You should consider an investment based on your investment time horizon and/or risk tolerance.',
      ],
      modalCryptoHeader: 'Crypto Risk Disclosure',
      modalCryptoContent: [
        'Investing in cryptoassets involves significant risk and can result in the loss of your invested capital. You should not invest more than you can afford to lose and should ensure that you fully understand the risks involved. Before investing, please take into consideration your level of experience, investment objectives, and seek independent financial advice if necessary. It is your responsibility to ascertain whether you are permitted to use our services based on the legal requirements in your country of residence.',
        'Investments in cryptoassets are not covered by the Financial Ombudsman Service or subject to protection under the Financial Services Compensation Scheme. The information on this site is not directed at residents of the United States, Canada, Singapore, Japan, Australia, and New Zealand or any particular country or jurisdiction where such distribution or use would be contrary to local law or regulation.',
      ],
      documents: 'Documents',
      riskInformation: 'Risk Information',
      defaultRiskInformationBlurb: 'When you invest, your capital is at risk meaning that your investments can rise and fall in value and you may get back less than you invested. Before investing, consider your investment objectives and any fees and expenses that may be charged.\n\nPerformance shown is based on the selected period. Past performance is not indicative of future performance. All pricing and performance data is shown before fees and is provided by third parties to Altify.\n\nThe content provided is for informational purposes only and is not investment or financial, tax or legal advice, an offer, solicitation of an offer, or advice to buy or sell or hold any investment products.\n\n[Crypto Risk Disclosure](https://cdn.altify.app/files/disclosures/Altify_Crypto_Risk_Disclosure.pdf)\n[General Risk Disclosure](https://cdn.altify.app/files/disclosures/Altify_General_Risk_Disclosure.pdf)',
      stocksRiskInformationBlurb: 'When you invest, your capital is at risk meaning that your investments can rise and fall in value and you may get back less than you invested. Before investing, consider your investment objectives and any fees and expenses that may be charged.\n\nPerformance shown is based on the selected period. Past performance is not indicative of future performance. All pricing and performance data is shown before fees and is provided by third parties to Altify.\n\nThe content provided is for informational purposes only and is not investment or financial, tax or legal advice, an offer, solicitation of an offer, or advice to buy or sell or hold any investment products.\n\n[Tokenised Stocks Risk Disclosure](https://cdn.altify.app/files/disclosures/Altify_Tokenised_Stocks_Risk_Disclosure.pdf)\n[General Risk Disclosure](https://cdn.altify.app/files/disclosures/Altify_General_Risk_Disclosure.pdf)',
      documentsBlurb: 'See additional product-specific disclosures in the Factsheet.',
      bundleMethodology: 'Crypto Bundle Methodology',
      breakdown: 'Breakdown',
    },
    cryptoDeposit: {
      backText: '← Back',
      cryptoIconAlt: 'crypto-asset',
      typesHeading: 'Deposit crypto',
      typesSubHeading: 'Please select a cryptocurrency',
      price: 'Price',
      modalAlt: 'pending-deposit',
      modalHeadingCrypto: 'Pending deposit',
      modalContentCrypto:
        'You already have a deposit pending, if you would like to change your deposit please select cancel and create a new one.',
      modalProfileCrypto: 'Back to profile',
      modalCancelCrypto: 'Cancel deposit',
      assetNetworkHeading: 'Network',
      noResultsFound: 'No results found',
      searchAssets: 'Search assets',
    },
  },
};

export default messages;
